export class Register{
    
    constructor(
        public firstName: string,
        public lastName: string,
        public email: string,
        public mobile: string,
        public mobileNumber: string,
        public mobileCode: any,
        public country: string,
        public username: string,
        public password: string,
        public passwordConf: string,
        public captcha: any,
        public token: string
    ) {  }
}